import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { COMPANY_LINKS, LEGAL_LINKS, SHOP_LINKS } from "@/content/nav";
import { useSite } from "@/context/Providers";

const AREAS = [
  ["park-view", "Park View"], ["petworth", "Petworth"], ["columbia-heights", "Columbia Heights"], ["shaw", "Shaw"],
  ["u-street", "U Street"], ["capitol-hill", "Capitol Hill"], ["noma", "NoMa"], ["georgetown", "Georgetown"],
];

const Col = ({ title, links }) => (
  <div>
    <h2 className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-gold">{title}</h2>
    <ul className="mt-4 space-y-2.5">
      {links.map((l) => <li key={l.to}><Link to={l.to} className="text-sm text-gray-400 hover:text-white">{l.label}</Link></li>)}
    </ul>
  </div>
);

export const Footer = () => {
  const s = useSite();
  return (
    <footer className="border-t border-line bg-[#08090C] pb-24 pt-16 lg:pb-10" data-testid="site-footer">
      <div className="container-x grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
        <div>
          <Link to="/" className="flex items-center gap-3" aria-label="SHADC Dispensary home">
            <img src="/brand/shadc-logo-192.webp" alt="SHADC Dispensary logo" width="64" height="64" loading="lazy" className="h-16 w-16" />
            <span className="font-display text-2xl font-bold text-white">SHA<span className="text-gold">DC</span></span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-gray-400">Cannabis dispensary and delivery on Georgia Avenue NW, serving adults 21+ across Washington, DC.</p>
          {s && (
            <address className="mt-6 space-y-3 text-sm not-italic text-gray-300" data-testid="footer-nap">
              <p className="flex gap-3"><MapPin className="h-4 w-4 shrink-0 text-gold" aria-hidden />{s.address.street}, {s.address.city}, {s.address.region} {s.address.postal}</p>
              <p className="flex gap-3"><Phone className="h-4 w-4 shrink-0 text-gold" aria-hidden /><a href={`tel:${s.phone}`} className="hover:text-gold">{s.phone_display}</a></p>
              <p className="flex gap-3"><Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden /><a href={`mailto:${s.email}`} className="break-all hover:text-gold">{s.email}</a></p>
              <p className="flex gap-3"><Clock className="h-4 w-4 shrink-0 text-gold" aria-hidden /><span>{s.hours.map((h) => `${h.days}: ${h.label}`).join(" · ")}</span></p>
            </address>
          )}
        </div>
        <Col title="Shop" links={SHOP_LINKS} />
        <Col title="Delivery Areas" links={[{ label: "All of Washington, DC", to: "/locations/dc/" }, ...AREAS.map(([s2, n]) => ({ label: n, to: `/locations/${s2}/` }))]} />
        <Col title="Company" links={COMPANY_LINKS} />
        <Col title="Policies" links={LEGAL_LINKS} />
      </div>
      <div className="container-x mt-14 border-t border-line pt-8 text-xs leading-relaxed text-gray-500">
        <p>For use only by adults 21 years of age and older. Keep cannabis out of reach of children and pets. Do not drive or operate machinery after consuming cannabis. Cannabis is not permitted on federal property.</p>
        <p className="mt-2">[Regulatory disclaimer placeholder — final compliance copy to be provided and approved by SHADC.]</p>
        <p className="mt-4">© {new Date().getFullYear()} SHADC Dispensary. All rights reserved.</p>
      </div>
    </footer>
  );
};
